export default "__VITE_ASSET__BP_k2A2c__"